import React, {Fragment, useEffect} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import $ from "jquery";

import {copySqftImagesToAnotherJob, saveQuote} from "../../../api/server-api";
import {
  changeUserInfo,
  checkForOrderCompletePopup,
  setJobId, setUiPopupState,
  showCheckoutLayout,
  toggleUserPopup
} from "../../../actions/actionFunctions";
import {showQuoteSavedNotification} from "../../ui/successNotification";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import {getCustomerById, userRegister} from "../../../api/user-api";
import {CONTENT_TYPES} from "./assignQuoteConstants";
import {setAssignQuoteCloneMode, setAssignQuotePopupCustomer} from "../../../actions/assignPopupFunctions";
import store from "../../../store";
import ActionTypes from "../../../misc/actionTypes";
import {setAlreadyRegisteredUserInfo} from "../../../actions/userFunctions";
import Config, {IS_AS_WORK_ORDER, IS_LOOK_JOURNEY, IS_OFFLINE_MODE} from "../../../config";
import {getUpdatedUserInfoFromTheResponse} from "../../../misc/userFunctions";
import {getSelectedContracts, shouldUseContractSigning} from "../contractSign/contractsFunctions";
import {UI_POPUP_TYPES} from "../../../reducers/messageBoxReducer";
import {setContractIMEFieldsValues} from "../../../actions/contractsActions";
import {LOOK_OVERLAYS} from "../../look/core/constants";
import {setLookOverlayOpened} from "../../../actions/lookFunctions";
import {setLookAiImageOpened} from "../../ai/aiActions";
import Misc from "../../../misc/misc";
// import {setAssignQuotePopupSuccessText} from "../../../actions/assignPopupFunctions";


const AssignQuotePopupSaveButtons = (props) => {

  const {closePopup, assignQuotePopupEmployee, userInfo, setJobId, changeUserInfo, changeContext, fabricatorData,
    contentType, updateInputValidations, assignQuoteCloneMode, setAssignQuoteCloneMode, quotes,
    setAssignQuotePopupCustomer, toggleUserPopup, alreadyRegisteredUserInfo, setAlreadyRegisteredUserInfo,
    assignQuotePopupSaveButtons, contractsList, setContractIMEFieldsValues, setUiPopupState, lookOverlayAction,
    setLookOverlayOpened, setLookAiImageOpened} = props;

  const fabricatorSettings = fabricatorData.settings;
  let {assignQuotePopupCustomer} = props;

  const saveIMEContractValues = (closeIMEPopup, popupContext) => {
    if (Config.isDevMode()) {
      console.log("saveIMEContractValues", popupContext);
    }
    setContractIMEFieldsValues(popupContext.IMEFieldsValues);
    closeIMEPopup();
    assignQuote(false, false, true, false, true);
  }

  const showImePopup = () => {
    setUiPopupState({
      headerTextId: "overlays.specifications",
      className: "",
      style: {maxWidth: "560px", maxHeight: "520px"},
      opened: true,
      type: UI_POPUP_TYPES.imeValues,
      context: {},
      // onCloseClick: (isCancel) => {
      //   if (isCancel) {
      //     closeContracts();
      //   }
      // },
      buttons: [{}, {
        isSaveButton: true,
        className: "ui-button2 text-uppercase ui-button2--green u-ml-1",
        textId: "buttons.save",
        onClick: saveIMEContractValues,
      }],
    });
  };

  const assignQuote = async (withCheckoutLogic, saveFromAlreadyRegisteredUser = false, showReceipt = true, saveFromOfflineContract = false, skipIMEpopup = false) => {
    if (contentType === CONTENT_TYPES.newCustomer && !saveFromAlreadyRegisteredUser) {

      await updateInputValidations();
      const errors = store.getState().userState.userInfoErrors;
      if (Object.keys(errors).length && Object.keys(errors).some(key => errors[key] && errors[key].length)) {
        return false
      }

      loaderEnable("loader.savingQuoteText");
      const registered = await userRegister({
        assignQuote: true,
        withCheckoutLogic,
        noInternetCallBack: assignQuote.bind(this, withCheckoutLogic, saveFromAlreadyRegisteredUser),
        afterContractSignCallback: assignQuote.bind(this, false, saveFromAlreadyRegisteredUser, false, true),
      });
      console.log("successfully registered", registered);
      if (registered) {
        assignQuotePopupCustomer = { // clear current selected customer
          id: registered.id || registered.userId,
          email: userInfo.email || registered.email,
          fullName: userInfo.firstName + (userInfo.lastName ? " " + userInfo.lastName : ""),
        }
        setAssignQuotePopupCustomer(assignQuotePopupCustomer);
      } else {
        return false
      }
    } else if (!assignQuotePopupCustomer) { // contentType === CONTENT_TYPES.searchCustomer
      changeContext({customerError: "assignPopup.customersTitleError"});
      return false
    }

    if (fabricatorData.isAmericanStandard && IS_AS_WORK_ORDER && !withCheckoutLogic && !skipIMEpopup) {
      closePopup();
      showImePopup();
      return
    }

    loaderEnable("loader.savingQuoteText");

    const newChangesExist = assignQuoteCloneMode || (contentType === CONTENT_TYPES.newCustomer) ||
      (assignQuotePopupCustomer || assignQuotePopupEmployee) && (
        (assignQuotePopupCustomer && (assignQuotePopupCustomer.email !== userInfo.email))
        || (assignQuotePopupEmployee && (assignQuotePopupEmployee.id !== userInfo.employeeId))
      )
    if (newChangesExist) {
      document.kvConfig.jobId = null; // creating a new quote
      await setJobId(0);  // creating a new quote
    }
    if (assignQuotePopupCustomer || assignQuotePopupEmployee) {
      let newUserInfo = {};
      if (assignQuotePopupCustomer && assignQuotePopupCustomer.id) {
        const fullNameObj = Misc.parseFullNameToFirstNameAndLastName(assignQuotePopupCustomer.fullName);
        newUserInfo.firstName = fullNameObj.firstName;
        if (fullNameObj.lastName) {
          newUserInfo.lastName = fullNameObj.lastName;
        }
        newUserInfo.email = assignQuotePopupCustomer.email;
        const responseCustomer = await getCustomerById({
          customerId: assignQuotePopupCustomer.id,
          showContractOnError: withCheckoutLogic,
          noInternetCallBack: assignQuote.bind(this, withCheckoutLogic, saveFromAlreadyRegisteredUser),
          afterContractSignCallback: assignQuote.bind(this, false, saveFromAlreadyRegisteredUser, false, true),
        }); // receive other data from BE
        console.log("responseUser", responseCustomer);
        if (responseCustomer) {
          newUserInfo = getUpdatedUserInfoFromTheResponse(newUserInfo, responseCustomer);
        } else if (IS_OFFLINE_MODE) {
          return false
        }
        console.log("newUserInfo", newUserInfo);
      }
      if (assignQuotePopupEmployee) {
        newUserInfo.employeeId = assignQuotePopupEmployee.id;
      }
      await changeUserInfo(newUserInfo);
      await toggleUserPopup({
        userIsLoggedIn: true,
        isPhoneNumberValidated: true
      });
    }

    const isFinalSave = assignQuoteCloneMode // is cloning mode
      || !withCheckoutLogic // is regular save (no need for checkout)
      || !shouldUseContractSigning(fabricatorSettings, contractsList) // we will save them after contract is completed

    const fromAI = lookOverlayAction === "aiLeadCapture";

    const {isVisible} = store.getState().contractSigningState;
    return saveQuote({
      submit: true,
      fromCheckOutPage: true,
      assignQuotePopupCustomer: newChangesExist && assignQuotePopupCustomer ? assignQuotePopupCustomer : null,
      assignQuotePopupEmployee: newChangesExist && assignQuotePopupEmployee ? assignQuotePopupEmployee : null,
      showContractSignOnError: true,
      showReceipt: showReceipt && !isVisible && !IS_LOOK_JOURNEY,
      skipSavingDocuments: !isFinalSave
    })
      .then((responseData) => {
        showQuoteSavedNotification("assignPopup.successNotification");
        closePopup();
        $(document).trigger(ActionTypes.USER_IS_LOGGED_IN);
        if (assignQuoteCloneMode) {
          quotes.forEach((quote, quoteIndex) => {
            if (quote.sqFtCalcData && quote.quoteId && responseData.quotesId && responseData.quotesId[quoteIndex]) {
              console.log("cloning quote sqft data... index:", quoteIndex, "from quote.quoteId", quote.quoteId, "-> to:", responseData.quotesId[quoteIndex]);
              copySqftImagesToAnotherJob(document.kvConfig.userId, {
                fromQuoteId: quote.quoteId,
                toQuoteId: responseData.quotesId[quoteIndex]
              })
            }
          })
          setAssignQuoteCloneMode(false);
        }
        // setAssignQuotePopupSuccessText(newChangesExist ? "assignPopup.successScreenText" : "assignPopup.successScreenSaveText");
        loaderDisable();
        if (withCheckoutLogic) {
          showCheckoutLayout(fabricatorSettings)
        } else if ((assignQuotePopupSaveButtons !== "updateTax") && !saveFromOfflineContract) {
          checkForOrderCompletePopup(fabricatorSettings);
          const receiptUrl = store.getState().printState.receiptUrl;
          if (showReceipt && receiptUrl && !responseData.receiptPrinted && !IS_LOOK_JOURNEY) {
            window.open(receiptUrl, "_blank");
          }
          if (fromAI) { // look journey, fromAI
            setTimeout(() => {
              setLookOverlayOpened(LOOK_OVERLAYS.aiPanel);
              setLookAiImageOpened(true);
            }, 350)
          }
        } else if (fromAI) { // look journey, fromAI
          setTimeout(() => {
            setLookOverlayOpened(LOOK_OVERLAYS.aiPanel);
            setLookAiImageOpened(true);
          }, 350)
        }
        return responseData
      })
  };

  useEffect(() => {
    if (alreadyRegisteredUserInfo.assignQuote && alreadyRegisteredUserInfo.confirmedAssign) {
      setAlreadyRegisteredUserInfo({confirmedAssign: false}); // first remove triggering it again
      assignQuote(alreadyRegisteredUserInfo.withCheckoutLogic, true); // assign quote on customer that was set in confirm popup
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alreadyRegisteredUserInfo]);

  if (assignQuotePopupSaveButtons === "updateTax") {
    return (
      <button className="ui-button2 ui-button2--green" onClick={() => assignQuote(false, false, false)}>
        <FormattedMessage id="assignPopup.updateAndClose"/>
      </button>
    )
  }

  const showSaveButton = assignQuotePopupSaveButtons !== "checkout";

  const showCheckoutButton = (assignQuotePopupSaveButtons !== "save") && (fabricatorSettings.enableDeposit || fabricatorSettings.enableDocuSign
    || fabricatorSettings.useContractSigning || (fabricatorSettings.checkout && fabricatorSettings.hasPaymentGateway));

  const checkoutButtonText = fabricatorData.settings.useContractSigning
    ? "contractSign.sign"
    : "assignPopup.checkoutButton";

  //always show contracts page if job has work order id
  const signIsDisabled = fabricatorData.settings.useContractSigning
    && (fabricatorData.isAmericanStandard
      ? getSelectedContracts(contractsList).length <= 1 && !IS_AS_WORK_ORDER
      : !getSelectedContracts(contractsList).length);

  return (
    <Fragment>
      {showSaveButton ? (
        <button className="ui-button2 ui-button2--green" onClick={() => assignQuote(false)}>
          <FormattedMessage id="assignPopup.saveQuoteButton"/>
        </button>
      ) : null}
      {showCheckoutButton ? (
        <button className={"ui-button2 " + (signIsDisabled ? " ui-button2--gray" : " ui-button2--green")}
                disabled={signIsDisabled}
                onClick={() => assignQuote(true)}>
          <FormattedMessage id={checkoutButtonText}/>
        </button>
      ) : null}
    </Fragment>
  )
};

AssignQuotePopupSaveButtons.propTypes = {
  updateInputValidations: PropTypes.func.isRequired,
  closePopup: PropTypes.func.isRequired,
  changeContext: PropTypes.func.isRequired,
  contentType: PropTypes.oneOf([
    CONTENT_TYPES.searchCustomer,
    CONTENT_TYPES.newCustomer
  ]),
}

const mapStateToProps = (store) => {
  const {userInfo, alreadyRegisteredUserInfo} = store.userState;
  const {assignQuotePopupCustomer, assignQuotePopupEmployee, assignQuoteCloneMode, assignQuotePopupSaveButtons} = store.assignQuoteState;
  const {quotes} = store.quotesState;
  const {contractsList} = store.contractSigningState;
  const {lookOverlayAction} = store.lookState;

  return {
    assignQuotePopupCustomer,
    assignQuotePopupEmployee,
    assignQuoteCloneMode,
    assignQuotePopupSaveButtons,
    fabricatorData: store.fabricatorState,
    userInfo,
    quotes,
    alreadyRegisteredUserInfo,
    contractsList,
    lookOverlayAction,
  };
};

const mapDispatchToProps = {
  setJobId,
  changeUserInfo,
  showQuoteSavedNotification,
  setAssignQuotePopupCustomer,
  setAssignQuoteCloneMode,
  toggleUserPopup,
  setAlreadyRegisteredUserInfo,
  setUiPopupState,
  setContractIMEFieldsValues,
  setLookOverlayOpened,
  setLookAiImageOpened,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupSaveButtons)
)
